import React from 'react';
import { capitalize } from 'lodash';

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { PaymentDetails } from 'types/payment_details';

interface Props {
  paymentMethod: PaymentDetails | null;
}

// Stripe's card brands, against the Font Awesome icon for each
const CARD_ICONS = {
  amex: 'cc-amex',
  diners: 'cc-diners-club',
  discover: 'cc-discover',
  jcb: 'cc-jcb',
  mastercard: 'cc-mastercard',
  visa: 'cc-visa'
};

const PaymentMethodSummary: React.FC<Props> = (props) => {
  if (!props.paymentMethod) return <div>No card on file.</div>;

  const { cardBrand, cardLast4 } = props.paymentMethod;

  return (
    <div className="align-items-center d-flex gap-xs">
      <FontAwesomeIcon icon={CARD_ICONS[cardBrand] || 'credit-card'} />

      <div>
        {cardBrand && cardLast4 ? `${capitalize(cardBrand)} ending in ${cardLast4}` : 'Card on file'}
      </div>
    </div>
  );
};

export default PaymentMethodSummary;
